import React from "react";

import router from "@/__main__/router.mjs";
import { DisplayError } from "@/app/ErrorBoundary.jsx";

function InitialComponent() {
  const error = router.error || new Error("Failed to load initial data.");

  return <DisplayError error={error} />;
}

export default InitialComponent;
